import { InputAdornment, TextField, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { FieldErrors, UseFormRegister } from 'react-hook-form';

import BoxDimention from '@/assets/common/boxDimention';
import WeightDimention from '@/assets/common/weightDimention';
import { StatusChip } from '@/components/Cards/Chips/StatusChip';

import { CreateOrderFormType } from '../create-order-schema';

interface PackageWeight {
  text: string;
  min: number;
  max: number;
  code: string;
}

const inputsData = [
  {
    title: 'Largo',
    name: 'items.length',
    Icon: <BoxDimention sx={{ width: '20px', height: '20px' }} />,
    measure: 'cm',
  },
  {
    title: 'Alto',
    name: 'items.height',
    Icon: null,
    measure: 'cm',
  },
  {
    title: 'Ancho',
    name: 'items.width',
    Icon: null,
    measure: 'cm',
  },
  {
    title: 'Peso',
    name: 'items.peso',
    Icon: <WeightDimention sx={{ width: '20px', height: '20px' }} />,
    measure: 'kg',
  },
];

interface VolumeCalculatorProps {
  calculatedSize: PackageWeight | undefined;
  register: UseFormRegister<CreateOrderFormType>;
  errors: FieldErrors<CreateOrderFormType>;
}

const VolumeCalculator = ({ calculatedSize, register }: VolumeCalculatorProps) => {
  const theme = useTheme();
  return (
    <Box>
      <Typography variant="body1" sx={{ color: theme.palette.grey[500] }}>
        Esto te ayudará a calcular el tamaño de paquete que debes seleccionar para tu envío.
      </Typography>

      {/* Inputs Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-2 gap-4 w-full my-5">
        {inputsData.map((input, index) => (
          <InputCalculate key={`${input.name}-${index}`} {...input} register={register} />
        ))}
      </div>

      <Typography variant="body1" sx={{ marginTop: '1rem', color: theme.palette.grey[500] }}>
        La dimensión de tu paquete corresponde a:{' '}
        {calculatedSize?.text && (
          <StatusChip status={calculatedSize.text} color="#72b632" bg="#daedc6" />
        )}
      </Typography>
    </Box>
  );
};

export default VolumeCalculator;

interface InputCalculateProps {
  title: string;
  name: string;
  Icon: React.ReactNode;
  measure: string;
  register: UseFormRegister<CreateOrderFormType>;
}

const InputCalculate = ({ title, name, Icon, measure, register }: InputCalculateProps) => {
  return (
    <TextField
      {...register(name as any)}
      type="number"
      size="small"
      variant="outlined"
      fullWidth
      label={title}
      placeholder="0"
      slotProps={{
        input: {
          startAdornment: Icon ? (
            <InputAdornment position="start" sx={{ color: 'primary.main' }}>
              {Icon}
            </InputAdornment>
          ) : null,
          endAdornment: <InputAdornment position="end">{measure}</InputAdornment>,
          onFocus: (e: React.FocusEvent<HTMLInputElement>) => {
            if (e.target.value === '0') {
              e.target.value = '';
            }
          },
          onBlur: (e: React.FocusEvent<HTMLInputElement>) => {
            if (e.target.value === '') {
              e.target.value = '0';
            } else if (Number(e.target.value) < 0) {
              e.target.value = '0';
            }
          },
        },
      }}
    />
  );
};
